package com.eladfinish.bible.contest.utils

import com.eladfinish.bible.contest.extensions.formatString
import kotlin.math.ln
import kotlin.math.pow

fun listOneToN(n: Int): List<Int> = List(size = n) { it.plus(1) } // 1...n

fun wrappedTopicsWithAsterisks(vararg items: String): List<String> =
    items.map { "*$it*" }

fun wrappedTopicsWithAsterisks(items: List<String>): List<String> =
    wrappedTopicsWithAsterisks(*items.toTypedArray())

fun humanReadableByteCount(bytes: Long, si: Boolean): String {
    val unit = if (si) 1000 else 1024
    if (bytes < unit) return "$bytes B"
    val exp = (ln(bytes.toDouble()) / ln(unit.toDouble())).toInt()
    val pre = (if (si) "kMGTPE" else "KMGTPE")[exp - 1].toString() + if (si) "" else "i"
    return "%.1f %sB".formatString((bytes / unit.toDouble().pow(exp.toDouble())).toString(), pre)
}
